/**
 * [generateRandomInt]
 * @param min number (inclusive)
 * @param max number (inclusive)
 * @returns number >= min && <= max
 */
export function generateRandomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}
